import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

const API_URL = import.meta.env.VITE_API_URL || 'https://api.gpmeta.au'

export type AccessStatus = 'loading' | 'allowed' | 'denied'

export function useAccess(): { status: AccessStatus; recheck: () => void } {
  const [status, setStatus] = useState<AccessStatus>('loading')
  const [tick, setTick] = useState(0)

  useEffect(() => {
    let cancelled = false

    async function check() {
      try {
        const { data } = await supabase.auth.getSession()
        const token = data.session?.access_token
        const headers: Record<string, string> = {}
        if (token) headers['Authorization'] = `Bearer ${token}`

        const res = await fetch(`${API_URL}/access/check`, { headers })
        if (!res.ok) {
          if (!cancelled) setStatus('denied')
          return
        }
        const body = (await res.json()) as { allowed: boolean }
        if (!cancelled) setStatus(body.allowed ? 'allowed' : 'denied')
      } catch {
        if (!cancelled) setStatus('denied')
      }
    }

    setStatus('loading')
    check()

    // Re-check when auth state changes (login may unlock email-allowlist).
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      check()
    })

    return () => {
      cancelled = true
      subscription.unsubscribe()
    }
  }, [tick])

  return { status, recheck: () => setTick((t) => t + 1) }
}
